import { createContext, useContext } from "react";

const MapActionsContext = createContext(null);

export const useMapActions = () => {
  const context = useContext(MapActionsContext);
  if (!context) {
    throw new Error("useMapActions must be used within a MapActionsProvider");
  }
  return context;
};

export default MapActionsContext;
